import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import { API_AUTH_URL, API_BASE_URL, THEME_CONFIG } from 'configs/AppConfig';
i18n.use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        backend: {
            
            //section 1: Run langauge in Minio
            loadPath: (API_BASE_URL + 'lang/{{ns}}/{{lng}}.json'),
            // loadPath: (API_AUTH_URL + 'api/openid_files/lang/{{ns}}/{{lng}}.json'),
            //section 2: Run language local in folder Public/assets for developver
            // loadPath: '/assets/i18n/{{ns}}/{{lng}}.json',
            
        },
        // fallbackLng: 'vi',
        fallbackLng: THEME_CONFIG.locale,
        lng: THEME_CONFIG.locale,
        // disabled in production
        debug: false,
        timeout: 5000,
        // can have multiple namespaces, in case you want to divide a huge
        // translation into smaller pieces and load them on demand
        // ns: ['common', 'home', 'article'],
        defaultNS: 'home',
        interpolation: { escapeValue: false },
        // react: {
        //     wait: true,
        //     // useSuspense: false
        // },
        cache: {
            enabled: true,
            prefix: 'i18n_',
            expirationTime: 1 * 60 * 60 * 1000, // cache 1 giờ
        },
    });

export default i18n;
